var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.969,
    height: 43.969,
    viewBox: "0 0 43.969 43.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M49.969,43.862a6.106,6.106,0,0,1-6.107,6.107H12.107A6.107,6.107,0,0,1,6,43.862V12.107A6.107,6.107,0,0,1,12.107,6H43.862a6.106,6.106,0,0,1,6.107,6.107Z",
    transform: "translate(-6 -6)",
    fill: "#0288d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M12,20.549h6.107V41.312H12Zm3.035-2.443H15a2.922,2.922,0,0,1-3-3.055A2.938,2.938,0,0,1,15.07,12a2.928,2.928,0,0,1,3.036,3.052A2.94,2.94,0,0,1,15.035,18.107ZM41.312,41.312H35.206V30.2c0-2.685-1.5-4.517-3.9-4.517A3.5,3.5,0,0,0,28,28.113a8.809,8.809,0,0,0-.123,2.207V41.312H21.771V20.549h6.107v3.2a6.177,6.177,0,0,1,5.787-3.2c4.37,0,7.647,2.748,7.647,8.884V41.312Z",
    transform: "translate(-4.672 -4.672)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ac6764f1cebe30f577a7c788d907da91.svg";
export { ForwardRef as ReactComponent };